function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Westlands-Stockist-Finder",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stockist-Finder---Landing-Page---Autofill---Desktop",
  transform: "translate(-786.000000, -533.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon---Location",
  transform: "translate(781.000000, 528.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,12.1211873 C13.8569576,12.1211873 12.1212328,13.8569576 12.1212328,15.9999545 C12.1212328,18.1429515 13.8569576,19.8787672 16,19.8787672 C18.1430424,19.8787672 19.8787672,18.142997 19.8787672,16 C19.8787672,13.857003 18.142997,12.1211873 16,12.1211873 Z M24.6690786,15.0302741 C24.2229883,10.9866435 21.0133111,7.77696623 16.9696804,7.3309214 L16.9696804,5.33333333 L15.0302741,5.33333333 L15.0302741,7.3309214 C10.9866435,7.77696623 7.77696623,10.9866435 7.3309214,15.0302741 L5.33333333,15.0302741 L5.33333333,16.9696804 L7.3309214,16.9696804 C7.77696623,21.0133111 10.9866889,24.2229883 15.0303196,24.6690786 L15.0303196,26.6666667 L16.9696804,26.6666667 L16.9696804,24.6690786 C21.0133111,24.2229883 24.2229883,21.0133111 24.6690786,16.9696804 L26.6666667,16.9696804 L26.6666667,15.0302741 L24.6690786,15.0302741 L24.6690786,15.0302741 Z M16,22.787854 C12.2521417,22.787854 9.21214601,19.7478583 9.21214601,16 C9.21214601,12.2521417 12.2521417,9.21214601 16,9.21214601 C19.7478583,9.21214601 22.787854,12.2520962 22.787854,16 C22.787854,19.7479038 19.7478583,22.787854 16,22.787854 Z",
  id: "Shape",
  fill: "#009FE3"
}))));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ba940b36.svg";
export { ForwardRef as ReactComponent };